export default "__VITE_ASSET__cf51e213__"